import { Component } from '@angular/core';

@Component({
  selector: 'app-monument-conservation-grant-request',
  templateUrl: './monument-conservation-grant-request.component.html',
  standalone: false,
})
export class MonumentConservationGrantRequestComponent {}
